/*eslint-disable*/
import React from "react";
import { Link, useHistory } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import classNames from "classnames";
import { headApi } from "utils/headApi";
import { imgApi } from "utils/imgApi";
import { localApi } from "utils/headApi.js";
import { makeStyles } from "@material-ui/core/styles";
import Parallax from "components/Parallax/Parallax.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import BanglesContact from "views/BanglesPage/Section/BanglesContact.js";
import BanglesCategory from "views/BanglesPage/Section/BanglesCategory.js";
import BanglesOverview from "views/BanglesPage/Section/BanglesOverview.js";
import BanglesComponent from "views/BanglesPage/Section/BanglesComponent.js";
import BanglesProject from "views/BanglesPage/Section/BanglesProject.js";
import BanglesFooter from "./Section/BanglesFooter.js";
import BanglesHeader from "./Section/BanglesHeader.js";
import HeaderLink from "./Section/BanglesHeaderLink.js";
import presentationStyle from "assets/jss/material-kit-pro-react/views/presentationStyle.js";

const useStyles = makeStyles(presentationStyle);

export default function BanglesPage() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });

  const classes = useStyles();
  const history = useHistory();

  const activeSession = sessionStorage.getItem("sessionData");

  const userObj = JSON.parse(sessionStorage.getItem("sessionData"));
  // const headApi = `https://api.bangles.org.in/api/rest`;

  const currentUrl = "https://bangles.org.in/";
  const seoTitle =
    "BANGLES ORG | Imitation Jewellery Manufacturer & Exporter in India";
  const seoDescription =
    "BANGLES ORG is a leading imitation jewellery manufacturer and exporter in India, offering stylish bangles, fashion jewellery, and wholesale designs for every occasion.";
  const seoKeywords =
    "BANGLES ORG is a leading imitation jewellery manufacturer and exporter based in Malad, Mumbai, India, offering stylish bangles in sizes such as 1mm, 2mm, 3mm, 4mm, 5mm, 5/2.5mm, 6mm, 6/3mm, 7mm, 7/3.5mm, 8mm, 8/4mm, 9mm, 9/4.5mm, 10mm, 10/5mm, 11mm, 11/5.5mm, 12mm, 12/6mm, 13mm, 13/6.5mm, 14mm, 14/7mm, 15mm, 15/7.5mm, 16mm, 16/8mm, 17mm, 17/8.5mm, 18mm, 18/9mm, 19mm, 19/9.5mm, 20mm, 20/10mm, and 25mm, including gold-plated items such as micro gold plating, tri-colour plating, 7 semanario sets, 3-tone plating, rose gold plating, rhodium plating, and silver plating. We also offer gold-plated meenakari bangles, 2-tone bangles, new Mexican bangles, gold-plated/oro laminado products, hoop earrings (round, big, and modern styles), 3-tone plated bangles, 3-tone U earrings, women’s earrings, animal-designed bangles, kids’ baby 6mm tri-colour bangles, Seven Day (Semanario) bangle bracelets, Mexican 14K gold bangles, three-tone bangles, dual-tone dolphin bypass bangles, dual-tone bangles, fashion jewellery, and wholesale designs for every occasion.";
  const ogImage =
    "https://inshabangles.com/imgstore/original_logo/IndianBanglesImgLogo.png";

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "BANGLES ORG",
    url: "https://bangles.org.in",
    logo: "https://inshabangles.com/imgstore/original_logo/IndianBanglesImgLogo.png",
    sameAs: ["https://bangles.org.in"],
  };

  const handleLogOut = () => {
    const finalURL =
      localApi + `/otp/logout/registerById/${userObj && userObj.id}`;
    fetch(finalURL, {
      method: "PUT",
      // headers: {
      //     "content-type": "application/json",
      //     accept: "application/json",
      // },
    })
      .then((response) => response.json())
      .then((response) => {
        //   console.log(response);
        if (response.error === true) {
          localStorage.removeItem("sessionDate");
          sessionStorage.removeItem("sessionData");
          history.push("/");
          window.location.reload(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div>
      <Helmet>
        <html lang="en" />
        <title>{seoTitle}</title>
        <meta name="description" content={seoDescription} />
        <meta name="keywords" content={seoKeywords} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={currentUrl} />

        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="BANGLES ORG" />
        <meta property="og:title" content={seoTitle} />
        <meta property="og:description" content={seoDescription} />
        <meta property="og:url" content={currentUrl} />
        <meta property="og:image" content={ogImage} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seoTitle} />
        <meta name="twitter:description" content={seoDescription} />
        <meta name="twitter:image" content={ogImage} />

        <script type="application/ld+json">
          {JSON.stringify(organizationSchema)}
        </script>
      </Helmet>
      <BanglesHeader
        brand="Home"
        links={<HeaderLink dropdownHoverColor="info" />}
        fixed
        color="transparent"
        changeColorOnScroll={{
          height: 100,
          color: "info",
        }}
      />
      <Parallax
        image={require("assets/img/bg4.jpg").default}
        className={classes.parallax}
      >
        <div className={classes.container}>
          <GridContainer>
            <GridItem>
              <div className={classes.brand}>
                <h1 style={{ color: "black" }}>
                  Bangles
                  <span className={classes.proBadge}>.Org</span>
                </h1>
                <h3 className={classes.title} style={{ color: "black" }}>
                  A Perfect Design for Perfect Women.
                </h3>
              </div>
              <div className={classes.brand}>
                <Link to="/bangles-sign-up">
                  <Button color="info" round>
                    Sign up
                  </Button>
                </Link>{" "}
                {!activeSession ? (
                  <Button color="info" round href="/bangles-login">
                    log in
                  </Button>
                ) : (
                  <Button color="info" round onClick={handleLogOut}>
                    log out
                  </Button>
                )}
              </div>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classNames(classes.main, classes.mainRaised)}>
        <BanglesComponent />
        <BanglesProject />
        <BanglesCategory />
        <BanglesOverview />
      </div>
      <BanglesContact />
      <BanglesFooter />
    </div>
  );
}
